import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import SelectDropDown from "../component/SelectDropDown";
import OtherService from "../services/Other";
import DefaultImage from "../assets/images/logo-small.png";
import RegistrationService from "../services/registration";
import toast from "react-hot-toast";
import {
  isMobileNumberValid,
  ValidatePhoneNumber,
} from "../constants/commonFunction";
import Form from "react-bootstrap/Form";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
const dateFormat = "YYYY-MM-DD";

const ServiceRegistration = () => {
  const userInfo = JSON.parse(localStorage.getItem("userData")).description;
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isPersonaList, setIsPersonaList] = useState([]);
  const [selectPersonaList, setSelectPersonaList] = useState({
    id: "",
    title: "",
  });
  const [isInfluencerList, setIsInfluencerList] = useState([]);
  const [selectInfluencerList, setSelectInfluencerList] = useState({
    id: "",
    title: "",
  });
  const [serviceRegistrationData, setServiceRegistrationData] = useState({
    customerName: "",
    mobile: "",
    serviceDate: "",
  });
  const [serviceChoose, setServiceChoose] = useState({
    id: "",
    title: "",
    productImage: "",
  });
  const [serviceNameValidationError, setServiceNameValidationError] =
    useState("");
  const [selectPersonaValidationError, setSelectPersonaValidationError] =
    useState("");
  const [influencerNameValidationError, setInfluencerNameValidationError] =
    useState("");
  const [customerNameValidationError, setCustomerNameValidationError] =
    useState("");
  const [mobileValidationError, setMobileValidationError] = useState("");
  const [serviceDateValidationError, setServiceDateValidationError] =
    useState("");
  const [serviceList, setServiceList] = useState([]);

  const handleServiceChange = (selected) => {
    setServiceChoose(selected);
    setServiceNameValidationError("");
  };

  const handleServiceRegistrationInput = (e) => {
    const { name, value } = e.target;
    const numberPattern = new RegExp(/^\d*$/);
    if (name == "customerName") {
      const customerNameRegex = /^[a-zA-Z]*$/;
      if (customerNameRegex.test(value) || value.length === 0) {
        setCustomerNameValidationError("");
      } else {
        setCustomerNameValidationError("Invalid customer name");
        return;
      }
    }
    if (name == "mobile") {
      const mobileRegex = /[0-9]/;
      if (mobileRegex.test(value) || value.length === 0) {
        setMobileValidationError("");
      } else {
        setMobileValidationError("Invalid mobile number");
        return;
      }
    }
    if (name === "mobile" && !numberPattern.test(value)) return;
    setServiceRegistrationData({ ...serviceRegistrationData, [name]: value });
  };

  useEffect(() => {
    const PersonaSelectionList = async () => {
      try {
        const PersonaSelectFetch = await RegistrationService.getHierarchies();
        if (PersonaSelectFetch.success == true) {
          if (PersonaSelectFetch.response.hierarchiesDetails.length > 0) {
            const hierchiesList =
              PersonaSelectFetch.response.hierarchiesDetails.map((item) => ({
                id: item.id,
                title: item.name,
              }));
            setIsPersonaList(hierchiesList);
          }
        }
      } catch (e) {
      }
    };
    PersonaSelectionList();
  }, []);

  useEffect(() => {
    const ProductFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const ProductFetchResponse = await OtherService.serviceProductList(
          token
        );
        if (
          ProductFetchResponse.success == true &&
          ProductFetchResponse.response.ProductDetails.length > 0
        ) {
          const filteredData = ProductFetchResponse.response.ProductDetails.map(
            (item, index) => {
              const productImageSrc =
                item.product_image == null
                  ? DefaultImage
                  : `https://dev-adani-dms.mjunction.in${item.product_image}`;
              return {
                id: item.id,
                title: item.product_name,
                productImage: productImageSrc,
              };
            }
          );
          setIsButtonLoading();
          setServiceList(filteredData);
        }
      } catch (e) {
      }
    };
    ProductFetch();
  }, []);

  useEffect(() => {
    const InfluencerFetch = async () => {
      try {
        if (!selectPersonaList.id) {
          console.warn("No persona selected. Skipping API call.");
          return;
        }
        const token = localStorage.getItem("access_token");
        if (!token) {
          console.error("Access token not found in localStorage.");
          return;
        }
        const InfluencerFetchResponse =
          await RegistrationService.getInfluencers(selectPersonaList.id, token);
        if (InfluencerFetchResponse?.success) {
          const { saleContractorDetails } =
            InfluencerFetchResponse.response || {};
          if (saleContractorDetails?.length > 0) {
            setIsInfluencerList(
              saleContractorDetails.map((item) => ({
                id: item.dcm_contacts_id,
                title: item.full_name,
              }))
            );
          } else {
            console.info("No influencers found for the selected persona.");
          }
        } else {
          console.error(
            "API call unsuccessful:");
        }
      } catch (e) {
        console.error("Error fetching influencers:");
      }
    };

    InfluencerFetch();
  }, [selectPersonaList.id]);

  const handlePersonaChange = (selectedValue) => {
    setSelectPersonaList(selectedValue);
    setSelectPersonaValidationError("");
  };

  const handleInfluencerChange = (selectedValue) => {
    setSelectInfluencerList(selectedValue);
    setInfluencerNameValidationError("");
  };

  const handleServiceRegistrationSubmit = async () => {
    if (userInfo == "Dealer") {
      let isValid = true;
      if (!selectPersonaList.id) {
        setSelectPersonaValidationError("Select persona is required");
        isValid = false;
      }
      if (!selectInfluencerList.id) {
        setInfluencerNameValidationError("Select influencer is required");
        isValid = false;
      }
      if (!serviceChoose.id) {
        setServiceNameValidationError("Service Name is required");
        isValid = false;
      }
      if (!serviceRegistrationData.customerName) {
        setCustomerNameValidationError("Customer Name is required");
        isValid = false;
      }
      if (!serviceRegistrationData.mobile) {
        setMobileValidationError("Mobile No is required");
        isValid = false;
      }
      if (!isMobileNumberValid(serviceRegistrationData.mobile)) {
        setMobileValidationError("Enter valid mobile number");
        isValid = false;
      }
      if (!serviceRegistrationData.serviceDate) {
        setServiceDateValidationError("Service Date is required");
        isValid = false;
      }
      const token = localStorage.getItem("access_token");
      const payload = {
        customer_name: serviceRegistrationData.customerName,
        mobile_number: String(serviceRegistrationData.mobile),
        product: serviceChoose.id,
        service_date: serviceRegistrationData.serviceDate,
        contractor_contact_id: selectInfluencerList.id,
      };
      if (isValid) {
        try {
          const DealerRegistrationSubmit =
            await OtherService.dealerServiceRegistration(token, payload);
          if (DealerRegistrationSubmit.success == true) {
            toast.success(DealerRegistrationSubmit.response.message);
            setTimeout(() => {
              navigate("/my-service");
            }, 2000);
          } else if (
            DealerRegistrationSubmit.success == false &&
            DealerRegistrationSubmit.message == "Bad request"
          ) {
            toast.error(DealerRegistrationSubmit.response.message);
          } else {
            toast.error("An error has occurred. Please try again.");
          }
        } catch (e) {
        }
      }
    } else {
      if (!serviceChoose.id) {
        return toast.error("Service Name is required");
      }
      if (!serviceRegistrationData.customerName) {
        return toast.error("Customer Name is required");
      }
      if (!serviceRegistrationData.mobile) {
        return toast.error("Mobile No is required");
      }
      if (!isMobileNumberValid(serviceRegistrationData.mobile)) {
        return toast.error("Enter a valid mobile no.");
      }
      if (!serviceRegistrationData.serviceDate) {
        return toast.error("Service Date is required");
      }
      const token = localStorage.getItem("access_token");
      const payload = {
        customer_name: serviceRegistrationData.customerName,
        mobile_number: serviceRegistrationData.mobile,
        service_date: serviceRegistrationData.serviceDate,
        products: [serviceChoose.id],
      };
      try {
        setIsButtonLoading(true);
        const ServiceRegistrationSubmit =
          await OtherService.saveServiceRegistration(payload, token);
        setIsButtonLoading(false);
        if (ServiceRegistrationSubmit.success == true) {
          toast.success(ServiceRegistrationSubmit.response.message);
          setTimeout(() => {
            navigate("/my-service");
          }, 2000);
        } else {
          toast.error("An error has occurred. Please try again.");
        }
      } catch (e) {
        setIsButtonLoading(false);
      }
    }
  };

  const today = new Date().toISOString().split("T")[0]; // max
    const fifteenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 15))
        .toISOString()
        .split("T")[0]; // min
    
    const minDate = dayjs(fifteenDaysAgo, "YYYY-MM-DD");
    const maxDate = dayjs(today, "YYYY-MM-DD");
    const disabledDate = (current) => {
      return current < minDate.startOf("day") || current > maxDate.endOf("day");
    };

  return (
    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion
        pageTitle="Service Registration"
        currentPageName="Service Registration"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  <h4 className="gradient-text">
                    Please Register Your Service
                  </h4>
                </div>
                <div className="dashboard-details">
                  <Row>
                    {userInfo == "Dealer" && (
                      <Col xs={12} lg={6}>
                        <SelectDropDown
                          labelName="Select Persona"
                          requiredStar="*"
                          options={isPersonaList}
                          selectedValue={selectPersonaList}
                          setSelectedValue={setSelectPersonaList}
                          onChange={handlePersonaChange}
                          page="searchFilter"
                        />
                        {selectPersonaValidationError && (
                          <div className="error-message">
                            {selectPersonaValidationError}
                          </div>
                        )}
                      </Col>
                    )}
                    {userInfo == "Dealer" && (
                      <Col xs={12} lg={6}>
                        <SelectDropDown
                          labelName="Select Influencer"
                          requiredStar="*"
                          options={isInfluencerList}
                          selectedValue={selectInfluencerList}
                          setSelectedValue={setSelectInfluencerList}
                          onChange={handleInfluencerChange}
                          page="searchFilter"
                        />
                        {influencerNameValidationError && (
                          <div className="error-message">
                            {influencerNameValidationError}
                          </div>
                        )}
                      </Col>
                    )}

                    <Col xs={12} lg={6}>
                      <SelectDropDown
                        labelName="Service Name"
                        requiredStar="*"
                        options={serviceList}
                        selectedValue={serviceChoose}
                        setSelectedValue={setServiceChoose}
                        onChange={handleServiceChange}
                        page="searchFilter"
                      />
                      {/* {serviceNameValidationError &&
                                                <div className="error-message">
                                                    {serviceNameValidationError}
                                                </div>
                                            } */}
                    </Col>
                    <Col xs={12} lg={6}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Customer Name"
                        name="customerName"
                        value={serviceRegistrationData.customerName}
                        onChange={handleServiceRegistrationInput}
                      />
                      {/* {customerNameValidationError &&
                                                <div className="error-message">
                                                    {customerNameValidationError}
                                                </div>
                                            } */}
                    </Col>
                    <Col xs={12} lg={6}>
                      <InputField
                        inputFieldLabel="Mobile No"
                        requiredStar="*"
                        name="mobile"
                        value={serviceRegistrationData.mobile}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            handleServiceRegistrationInput(e);
                          }
                        }}
                      />
                      {/* {mobileValidationError &&
                                                <div className="error-message">
                                                    {mobileValidationError}
                                                </div>
                                            } */}
                    </Col>
                    {/* <Col xs={12} lg={3}>
                                            <DatePicker
                                                inputFieldLabel="Service Date"
                                                requiredStar="*"
                                                name="serviceDate"
                                                value={serviceRegistrationData.serviceDate}
                                                onChange={handleServiceRegistrationInput}
                                            />
                                            {serviceDateValidationError &&
                                                <div className="error-message">
                                                    {serviceDateValidationError}
                                                </div>
                                            }
                                        </Col> */}
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Label>Service Date</Form.Label>
                      <DatePicker
                        defaultValue={serviceRegistrationData.serviceDate}
                        format={dateFormat}
                        disabledDate={disabledDate}
                        onKeyDown={(e) => e.preventDefault()}
                        className="w-100"
                        // onChange={handleServiceRegistrationInput}
                        onChange={(date, dateString) =>
                          handleServiceRegistrationInput({
                            target: { name: "serviceDate", value: dateString },
                          })
                        }
                        style={{ height: "43px" }}
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Submit"
                        }
                        disabled={isButtonLoading}
                        className={userInfo == "Dealer" ? "mt-4" : "mt-2"}
                        onClick={handleServiceRegistrationSubmit}
                      />
                    </Col>
                    {/* <Col xs={12} lg={3}>

                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }
                                        </Col> */}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ServiceRegistration;
